import { HOURS } from "./config";

const TZ = "America/Denver";

const denverNow = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: TZ, weekday: "short", hour: "numeric", minute: "numeric", hour12: false,
  }).formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type)?.value;
  const dayIndex = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(get("weekday"));
  const hour = Number(get("hour")) % 24;
  return { day: dayIndex, minutes: hour * 60 + Number(get("minute")) };
};

const fmt = (h, lang) => {
  const suffix = h >= 12 ? "PM" : "AM";
  const hr = h % 12 === 0 ? 12 : h % 12;
  return lang === "es" ? `${hr}:00 ${suffix}` : `${hr}:00 ${suffix}`;
};

export const getOpenStatus = (lang = "en", date = new Date()) => {
  const { day, minutes } = denverNow(date);
  const today = HOURS.find((h) => h.day === day);
  if (!today.closed && minutes >= today.open * 60 && minutes < today.close * 60) {
    return {
      isOpen: true,
      closesAt: fmt(today.close, lang),
      minutesToClose: today.close * 60 - minutes,
      todayHours: `${fmt(today.open, lang)} – ${fmt(today.close, lang)}`,
    };
  }
  const todayHours = today.closed ? null : `${fmt(today.open, lang)} – ${fmt(today.close, lang)}`;
  for (let i = 0; i < 7; i++) {
    const idx = (day + i) % 7;
    const h = HOURS.find((x) => x.day === idx);
    if (h.closed) continue;
    if (i === 0 && minutes >= h.close * 60) continue;
    const dayNames = lang === "es"
      ? ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
      : ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return { isOpen: false, todayHours, nextOpen: i === 0 ? fmt(h.open, lang) : `${dayNames[idx]} ${fmt(h.open, lang)}` };
  }
  return { isOpen: false, todayHours };
};

export const openingHoursSpecification = [
  { "@type": "OpeningHoursSpecification", dayOfWeek: ["Tuesday", "Wednesday", "Thursday"], opens: "11:00", closes: "21:00" },
  { "@type": "OpeningHoursSpecification", dayOfWeek: ["Friday", "Saturday"], opens: "11:00", closes: "22:00" },
];
